import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class KioskService {

    constructor(
        private http: HttpClient
    ) { }

    // Get All Store Specific Kiosks
    public getKiosksByStoreConfig(id) {
        return this.http.get(environment.apiUrl + 'api/ext-kiosk/by-store-config/' + id)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Get individual kiosk by id
    public getKioskById(id) {
        return this.http.get(environment.apiUrl + 'api/ext-kiosk/' + id)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Get all kiosks system wide
    public getAllKiosks() {
        return this.http.get(environment.apiUrl + 'api/ext-kiosk')
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Create a store kiosk
    public createKiosk(body) {
        return this.http.post(environment.apiUrl + 'api/ext-kiosk', body)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Edit a kiosk
    public editKiosk(obj) {

    }

    // Delete a kiosk
    public deleteKiosk(id) {
        return this.http.delete(environment.apiUrl + 'api/ext-kiosk/' + id)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // HANDLE DATA
    private handleData(res: HttpResponse<any>) {
        const body = res;
        return body;
    }

    public handleDataWithHeaders(res: HttpResponse<any>) {

        const headers = res.headers;
        const body = res.body;
        const data = {
            'headers': headers,
            'body': body
        };
        return data;
    }

    private handleError(error: any) {
        return Observable.throw(
            new HttpErrorResponse(error)
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/kiosk.service.ts